
<!-- 奖励账户转账弹窗 -->
<template>
  <div>
    <b-modal
      v-model="isShow"
      :title="$t('lanV4.Transfer')"
      centered
      scrollable
      no-close-on-backdrop
      @hide="onReset"
      id="agentRewardAccountModal"
    >
      <div id="agentRewardAccountModal" class="body-content">
        <!-- 币种 -->
        <b-row class="line">
          <b-col>
            <label>{{ $t("assetsList.coinSymbol") }}</label>
            <v-select v-model="symbol" :options="symbolList">
              <div slot="no-options">{{ $t("common.noFind") }}</div>
            </v-select>
          </b-col>
        </b-row>
        <!-- 从 -->
        <b-row class="line">
          <b-col>
            <label> {{ $t("transfer.from") }}</label>
            <v-select v-model="tranferAccount" :options="tranferAccountList">
              <div slot="no-options">{{ $t("common.noFind") }}</div>
            </v-select>
          </b-col>
        </b-row>
        <!-- 转入 -->
        <b-row class="line">
          <b-col>
            <label> {{ $t("transfer.to") }}</label>
            <v-select
              v-model="tranferAccountTo"
              :options="tranferAccountToList"
              :disabled="true"
            >
              <div slot="no-options">{{ $t("common.noFind") }}</div>
            </v-select>
          </b-col>
        </b-row>
        <!-- 转账金额 -->
        <b-row class="line">
          <b-col>
            <label
              ><i class="text-danger mar-r-2">*</i
              >{{ $t("transfer.transferAmount") }}</label
            >
            <b-input-group>
              <b-form-input
                class="append-input"
                v-model.trim="$v.form.tranferAmount.$model"
                autocomplete="off"
                :state="chkState('tranferAmount')"
                :class="{
                  'invalid-select-border': !$v.form.tranferAmount.required,
                }"
                placeholder=""
                maxLength="16"
              >
              </b-form-input>
              <div class="append"></div>
            </b-input-group>

            <p class="text-danger" v-if="!$v.form.tranferAmount.required">
              {{ $t("transfer.inputAmount") }}
            </p>
            <p class="text-danger" v-if="!$v.form.tranferAmount.proofValue">
              {{ $t("lanV4.feeFwErr") }}
            </p>
          </b-col>
        </b-row>
      </div>
      <template v-slot:modal-footer>
        <b-button
          class="coustom-btn"
          variant="primary"
          @click="save('saveData')"
          >{{ $t("common.save") }}</b-button
        >
        <b-button class="coustom-btn" variant="secondary" @click="onReset">{{
          $t("common.cancel")
        }}</b-button>
      </template>
    </b-modal>
    <!-- 谷歌验证 -->
    <b-modal
      v-model="googleModalShow"
      :title="$t('delivery.text7')"
      centered
      size="lg"
      scrollable
      no-close-on-backdrop
      @hide="onResetTwo"
      id="modal-box"
    >
      <div class="body-content">
        <b-row class="line">
          <b-col>
            <label>
              <!-- 谷歌验证码： -->
              {{ $t("assetsList.code") }}
            </label>
            <p class="text-danger" v-if="!googleStatus">
              <!-- 还未绑定谷歌验证码！请先点击右上角头像打开“个人中心”绑定谷歌验证码 -->
              {{ $t("assetsList.error1") }}
            </p>
            <b-form-input
              v-model.trim="$v.form.googleCode.$model"
              autocomplete="off"
              :state="chkState('googleCode')"
              maxLength="6"
              style="width: 100%"
            >
            </b-form-input>

            <p class="text-danger" v-if="!$v.form.googleCode.required">
              <!-- 请输入6位谷歌验证码 -->
              {{ $t("assetsList.error2") }}
            </p>
            <p class="text-danger" v-if="!$v.form.googleCode.proofValue">
              <!-- 请输入6位谷歌验证码 -->
              {{ $t("assetsList.error2") }}
            </p>
          </b-col>
        </b-row>
      </div>

      <template v-slot:modal-footer>
        <b-button
          class="coustom-btn"
          variant="primary"
          @click="hanldeGoogleSubmit"
          >{{ $t("common.save") }}</b-button
        >
        <b-button class="coustom-btn" variant="secondary" @click="onResetTwo">{{
          $t("common.cancel")
        }}</b-button>
      </template>
    </b-modal>
  </div>
</template>
        <script>
import { requiredIf } from "vuelidate/lib/validators";
import { newFixInput, multiply, divide, fixD } from "@/apis/newmethods";
export default {
  name: "agentRewardAccountModal",
  props: ["modalShow", "itemData", "brokerId"],
  data() {
    return {
      symbolList: [],
      symbol: null,
      tranferAccount: null, //转出账户
      tranferAccountList: [], //转出账户列表

      tranferAccountTo: null, //转入账户
      tipWidth: "200px",
      isShow: false,
      modalTitle: null,
      brokerList: [], // 商户名称列表

      form: {
        brokerId: null, //商户id
        tranferAmount: null, //转账金额
        googleCode: null,
      },
      actStartTimeErr: false, //有效期开始日期必须小于结束日期
      addSave: false,
      addSave2: false,
      saveFlag: true, //保存防二次点击
      googleModalShow: false, //谷歌验证码
      saveDataType: null, //是否点击转账金额保存
    };
  },
  watch: {
    // 转帐金额
    "form.tranferAmount"(v) {
      if (v) {
        // this.transferAmount = newFixInput(newVal, 8, { minus: true, num: true });
        this.$nextTick(() => {
          this.form.tranferAmount = newFixInput(v, 2, {
            minus: true,
            num: true,
            ints: 16
          });
        });
      }
    },
    "form.googleCode"(v) {
      if (v) {
        this.$nextTick(() => {
          this.form.googleCode = newFixInput(v, 0, { ints: 6 });
        });
      }
    },
    modalShow(v) {
      this.isShow = v;
    },
    symbol(v){
      if(v){
        this.getTranferAccountList()
      }
    }
  },
  computed: {
    // 转入账户列表
    tranferAccountToList() {
      return [
        {
          label: this.$t("lanV4.brokerRewardAccount"), //"公司：（现货 & 合约）经纪人奖励账户"
          value: 1000,
        },
      ];
    },
    // 类型
    feeTypeList() {
      return [
        { label: this.$t("lanV4.feeNewUser"), value: 1 }, //新用户
        { label: this.$t("lanV4.singleUser"), value: 2 }, //单用户
        { label: this.$t("lanV4.Allusers"), value: 3 }, //所有用户
      ];
    },

    isValid() {
      return !this.$v.form.$anyError;
    },
    url() {
      return this.$store.state.url.feeUser;
    },
    editDisabled() {
      if (this.modalType === "Edit") {
        return true;
      } else {
        return false;
      }
    },
    roleType() {
      if (this.$store.state.baseData.user) {
        return this.$store.state.baseData.user.roleType;
      }
    },
    // 是否开启谷歌
    googleStatus() {
      if (this.$store.state.baseData.user) {
        // return 0;
        return this.$store.state.baseData.user.googleStatus;
      }
    },
  },
  created() {
    this.isShow = this.modalShow;
    this.getSmbolList();
    this.tranferAccountTo = this.tranferAccountToList[0];
  },
  validations: {
    form: {
      // 转账金额
      tranferAmount: {
        required: requiredIf(function () {
          return this.addSave;
        }),
        proofValue: function (v) {
          if (v === "-0") {
            return false;
          }
          //   if (v) {
          //     return Number(v) >= 0 && Number(v) <= 100000000000;
          //   }
          return true;
        },
      },
      googleCode: {
        required: requiredIf(function () {
          return this.addSave2;
        }),
        proofValue: function (v) {
          if (v === "-0") {
            return false;
          }
          if (v) {
            return v.length == 6;
          }
          return true;
        },
      },
    },
  },
  methods: {
    // 获取保证金币种
    getSmbolList() {
      this.$http({
        url: this.$store.state.url.agent.getMarginCoinList,
        params: {
          companyId: this.brokerId ? this.brokerId.value : null,
          justUsdt: 0, //传1只显示usdt或者混合云usdt1753
        },
      }).then(({ data, code, msg }) => {
        if (data && code.toString() === "0") {
          let arr = [];
          if (data.coinList.length) {
            data.coinList.map((item) => {
              if (this.roleType == 0 || this.roleType == 1) {
                // 平台商户展示otherName 传参coin
                arr.push({ label: item.otherName, value: item.coin });
              }
              if (this.roleType == 3 || this.roleType == 4) {
                // 经纪人展示otherName 传参coin
                arr.push({ label: item.otherName, value: item.coin });
              }
            });
          }
          this.symbolList = arr;
          this.symbol = this.symbolDefaultValue();
          this.getTranferAccountList();
        } else {
          this.$bus.$emit("alert", { type: "error", message: msg });
        }
      });
    },
    symbolDefaultValue() {
      let data = [];
      if (this.symbolList && this.symbolList.length) {
        data = this.symbolList[0];
        this.symbolList.forEach((item) => {
          if (item.value === "USDT") {
            data = item;
          }
        });
      }
      return data;
    },
    // 获取转账账户列表
    getTranferAccountList() {
      this.$http({
        url: this.$store.state.url.agent.account_type_list,
        params: {
          companyId: this.brokerId ? this.brokerId.value : null,
          coin: this.symbol ? this.symbol.value : null,
        },
        // method: "get",
        // apiType: "fe-json-server",
      }).then(({ data, code, msg }) => {
        if (data && code.toString() === "0") {
          let arr = [];
          if (data.length) {
            data.map((item) => {
              arr.push({
                label:
                  item.accountTypeName +
                  "        " +
                  this.$t("lanV4.agentBalance", { balance: item.balance }),
                value: item.accountType,
              });
            });
          }
          this.tranferAccountList = arr;
          this.tranferAccount = arr[0];
          //   this.symbol = arr[0];
        } else {
          this.$bus.$emit("alert", { type: "error", message: msg });
        }
      });
    },
    // 保存
    save(saveData) {
      this.addSave = true;
      this.saveDataType = saveData;
      if (!this.validate()) {
        // this.$bus.$emit("alert", {
        //   type: "error",
        //   message: this.$t("lanV4.infoErr"),
        // });
        this.saveDataType = null;
        return;
      }

      if (!this.googleStatus) {
        // 没有绑定谷歌
        this.$bus.$emit("alert", {
          type: "error",
          message: this.$t("lanV4.googleCodeTip"),
        });
        this.isShow = true;
        this.saveDataType = null;
      } else {
        this.googleModalShow = true;
        this.isShow = false;
      }
    },
    // 提交谷歌吗
    hanldeGoogleSubmit() {
      this.addSave2 = true;
      if (!this.validate()) return;
      if (!this.saveFlag) return;
      this.saveFlag = false;
      const paramsData = {
        companyId: this.brokerId ? this.brokerId.value : null,
        coin: this.symbol ? this.symbol.value : null,
        accountType: this.tranferAccount //转账账户
          ? this.tranferAccount.value
          : null,
        googleCode: this.form.googleCode,
        balance: this.form.tranferAmount, //转账金额
      };
      this.$http({
        url: "/account_transfer",
        params: paramsData,
      }).then((data) => {
        this.saveFlag = true;
        if (data && data.code.toString() === "0") {
          this.$bus.$emit("alert", { type: "success", message: data.msg });
          this.$parent.getData();
          this.onResetTwo();
        } else {
          this.$bus.$emit("alert", { type: "error", message: data.msg });
        }
      });
    },
    onReset() {
      this.addSave = false;

      if (this.saveDataType !== "saveData") {
        this.$emit("changeModalShow", false);
        this.$emit("changeModalType", null);
      }

      this.$v.form.$reset();
    },
    onResetTwo() {
      this.googleModalShow = false;
      this.addSave2 = false;
      this.$emit("changeModalShow", false);
      this.$emit("changeModalType", null);
      this.$v.form.$reset();
    },
    chkState(val) {
      const field = this.$v.form[val];
      if (field.$dirty) {
        if (field.$invalid) {
          return false;
        }
        return null;
      }
      return null;
    },
    validate() {
      this.$v.form.$touch();
      return this.isValid;
    },
  },
};
</script>
<style lang="scss">
#agentRewardAccountModal {
  .modal-dialog {
    max-width: 600px !important;
  }
}
</style>
        
        